import React from 'react'


const Financier = ({ServiceClick}) => {
  return (
   
      <section className="financier-section"> 
  <div className="container">
    <div className="row">
      <div className="col-lg-6">
        <div className="financier-content">
          <h1>L'immobilier, <br />
            c’est <span> bien plus </span> <br />
            qu’un simple <br />
            <span> investissement</span> <br />
            financier.</h1>
        </div>
      </div>
      <div className="col-lg-6">
     
        <div className="financier-content">
          <p>Beatimo est la première firme d'actuaires spécialisés en investissement immobilier au Québec. Notre approche unique et holistique, combinant une expertise financière hors pair à l'expérience sur le terrain de projets immobiliers réels, nous permet de bien comprendre les besoins de nos clients et adresser de front les défis auxquels ils sont confrontés dans la croissance de leur société immobilière.
          </p>
          <p>Bénéficiez de l'expertise actuarielle au service de la saine croissance de votre portefeuille immobilier. Choisissez Beatimo comme votre partenaire à long terme pour vous accompagner vers l'accomplissement de vos rêves les plus fous!
          </p>
          <p>On cherche tous à accomplir de grandes choses. Maximisez votre impact. </p>
          <div className="financier-button" >
            <button className="services-btn" onClick={ServiceClick}>découvrir nos services</button>
            <button className="icon-btn" onClick={ServiceClick}><img src="./assets/image/arrow-bottom.png" alt="Financier-section" /></button>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</section>
  )
}

export default Financier
